import {Component, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import {CommonModule} from "@angular/common";
import {DashboardService} from "../../../_services/dashboard.service";
import {OrdersChartRequest} from "../../../_models/OrdersChartRequest";
import {ChartConfiguration, ChartData, Chart} from "chart.js";
import {map} from "rxjs/operators";
import {AuthService} from "../../../_services/auth.service";
import {NgChartsModule} from 'ng2-charts';
import DatalabelsPlugin from "chartjs-plugin-datalabels";
import {FormsModule} from '@angular/forms';
import {NgbDatepickerModule, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {RemedialsChartRequest} from "../../../_models/RemedialsChartRequest";



@Component({
  templateUrl: './dashboard.component.html',
  standalone: true,
  imports: [
    CommonModule,
    CommonModule,
    CommonModule,
    NgChartsModule,
    FormsModule,
    NgbDatepickerModule
  ],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit {
  constructor(private dashboardService: DashboardService, private authService: AuthService) {
    // this.toDate = new Date();
    // this.fromDate = new Date();
    // this.fromDate.setMonth(this.fromDate.getMonth() - 1);
    Chart.register(DatalabelsPlugin);
  }

  // @ViewChild('tabSet') tabSet: TabsetComponent;

  toDate: Date;
  fromDate: Date;
  fromDateStruct: NgbDateStruct;
  toDateStruct: NgbDateStruct;
  uninvoicedCount: number;
  uninvoicedValue: number;
  userId: string;
  public remedialPieChart: ChartConfiguration['options'];


  //Charts
  public contractsReqActionPieChart: ChartConfiguration['options'];
  public pieChartPlugins = [DatalabelsPlugin];

  ngOnInit() {
    this.authService.userProfile$.pipe(map(userProfile => {
      // this.userId = userProfile.id;
    })).subscribe();

    this.contractsReqActionPieChart = this.setChartOptions('Contracts requiring action')
    this.remedialPieChart = this.setChartOptions('Remedials Summary')

    const today = new Date();
    const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    const thisMonth = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    this.fromDate = lastMonth;
    this.toDate = thisMonth;

    this.fromDateStruct = {
      year: lastMonth.getFullYear(),
      month: lastMonth.getMonth() + 1,
      day: lastMonth.getDate()
    };

    this.toDateStruct = {
      year: thisMonth.getFullYear(),
      month: thisMonth.getMonth() +1,
      day: thisMonth.getDate()
    };

    this.loadChartData();
  }

  // selectTab(tabSet: TabsetComponent, tabId: number) {
  //   tabSet.tabs[tabId].active = true;
  // }

  private loadChartData() {
    let remedialsChartRequest = new RemedialsChartRequest();
    remedialsChartRequest.fromDate = this.fromDate;
    remedialsChartRequest.toDate = this.toDate;
    remedialsChartRequest.userId = 'temp';
    this.dashboardService.getRemedialChartData(remedialsChartRequest).subscribe(response => {
      this.remedialsPieChartData = {
        labels: [
          this.formatLabel('New', response.newCount),
          this.formatLabel('Pending Information', response.pendingInformationCount),
          this.formatLabel("Pending Approval", response.pendingApprovalCount),
          this.formatLabel("Approval", response.approvedCount),
          this.formatLabel("Rejected", response.rejectedCount),
          this.formatLabel("Complete", response.completeCount),
          this.formatLabel("Closed", response.closedCount),
          this.formatLabel("Trace Request", response.traceRequestCount),
          this.formatLabel("Created In Adminbase", response.createdInAdminbaseCount),

        ],
        datasets: [{
          data: [response.newCount, response.pendingInformationCount, response.pendingApprovalCount, response.approvedCount, response.rejectedCount,
            response.completeCount, response.closedCount, response.traceRequestCount, response.createdInAdminbaseCount]
        }]
      }
    })
  }

  public contractsSummaryPieChartData: ChartData<'pie', number[], string | string[]> = {
    labels: [],
    datasets: [{data: []}]
  }

  private formatLabel(label: string, value: number) {
    return `${label}: (${Math.round(value)})`;
  }

  public get showContractsReqActionPieChart() {
    return this.contractsReqActionPieChartData.datasets[0].data.filter(x => !!x).length
  };

  public contractsReqActionPieChartData: ChartData<'pie', number[], string | string[]> = {
    labels: [],
    datasets: [{data: []}]
  }

  // chartClicked($event: { event; active }) {
  //   if ($event.event.type !== 'click') {
  //     return;
  //   }
  //
  //   if (!$event.active.length) {
  //     return;
  //   }
  //
  //   let chartId = $event.event.chart.canvas.id;
  //   let label = $event.event.chart.legend.legendItems[$event.active[0].index].text.split(':')[0];
  //   // Format label to match query param 'On Hold' -> 'onHold'
  //   label = label.replace(' ', '');
  //   label = label[0] + label.slice(1);
  //
  //   switch (chartId) {
  //     case 'contractsReqAction':
  //       if (label == 'OnHold') {
  //         this.selectTab(this.tabSet, 5);
  //       } else if (label == 'MissingPurchase Order') {
  //         this.selectTab(this.tabSet, 6);
  //       } else if (label == 'MissingFinal Plan') {
  //         this.selectTab(this.tabSet, 7);
  //       } else {
  //         // this.router.navigate(['quotes', {onHoldStatus: [label]}])
  //       }
  //       break;
  //
  //   }
  // }

  private setChartOptions(title: string) {
    let basePieChartOptions: ChartConfiguration['options'] = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'top',
        },
        title: {
          display: true,
          text: title
        },
        datalabels: {
          formatter: (value, ctx) => {
            if (ctx.chart.data.labels) {
              return ctx.chart.data.labels[ctx.dataIndex];
            }
          },
        },
      }
    };

    return basePieChartOptions;
  }

//probs use a component wide date changer when you add a new chart
  onFromDateChange(date: NgbDateStruct) {
    // Convert struct to JS Date for the API, keeping the struct for the picker
    this.fromDateStruct = date;
    this.fromDate = new Date(date.year, date.month - 1, date.day);
    this.loadChartData();
  }

  onToDateChange(date: NgbDateStruct) {
    this.toDateStruct = date;
    this.toDate = new Date(date.year, date.month - 1, date.day);
    this.loadChartData();
  }

  public get ShowRemedialPieChart() {
    return this.remedialsPieChartData.datasets[0].data.filter(x => !!x).length
  };

  public remedialsPieChartData: ChartData<'pie', number[], string | string[]> = {
    labels: [],
    datasets: [{data: []}]
  }
}
